<template>
  <v-container fluid>
    <!-- top toolbar START -->
    <v-row>
      <v-col cols="12">
        <!-- top toolbar START -->
        <v-toolbar flat>
          <v-icon class="mr-3">mdi-send</v-icon>
          <v-toolbar-title>Invite Members to Himydata</v-toolbar-title>
        </v-toolbar>
        <!-- top toolbar END -->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-container fluid  grid-list-lg>
          <v-layout row wrap align-center justify-center>
            <!-- column names START -->
            <v-flex xs4 class="pa-4">
                <h4>Email address</h4>
            </v-flex>
            <v-flex xs2 v-for="privilege in privileges" :key="privilege.id">
              <v-btn class="text-xs-center" text @click.native="markAll(privilege)">{{privilege.text}}</v-btn>
            </v-flex>
            <v-flex xs2>
            </v-flex>
            <!-- column names END -->

            <!-- invite lines START -->
            <template v-for="(item, index) in invites">
              <!-- email field START -->
              <v-flex xs4 :key="index">
                <v-text-field
                  v-model="item.email"
                  :error-messages="errors ? errors.collect('email' + index) : ''"
                  v-validate="'email'"
                  :data-vv-name="'email' + index"
                  autofocus
                  placeholder="name@example.com"
                ></v-text-field>
              </v-flex>
              <!-- email field END -->

              <!-- checkboxes START -->
              <v-flex d-flex xs2 v-for="privilege in privileges" :key="privilege.name + index">
                <v-checkbox 
                  v-model="item.privileges[privilege.name]"
                  color="secondary"
                  class="ml-5"
                ></v-checkbox>    
              </v-flex>
              <!-- checkboxes END -->

              <!-- delete invite button START -->
              <v-flex xs2 class="text-xs-right" :key="'delete' + index">
                <v-btn class="mx-2" small fab @click.native="addInvite"><v-icon>mdi-plus</v-icon></v-btn>
                <v-btn class="mx-2" small fab @click.native="deleteInvite(index)"><v-icon>mdi-delete</v-icon></v-btn>
              </v-flex>
              <!-- delete invite button END -->
            </template>
            <!-- invite lines END -->
          </v-layout>
          <!-- 'add another' button START -->
          <!-- <v-flex class="mb-5">
            <v-btn outline @click.native="addInvite"><v-icon>mdi-plus</v-icon> add another</v-btn>
          </v-flex> -->
          <!-- 'add another' button END -->

          <!-- 'send invites' button START -->

          <v-flex class="text-xs-right mt-5">
            <v-btn large color="primary" @click.native="sendInvite">send invites</v-btn>
          </v-flex>
          <!-- 'send invites' button END -->
        </v-container>
    
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import SettingsService from './services/SettingsService'
  export default{
    $_veeValidate: {
      validator: 'new'
    },
    data: function() {
      return {
        privileges: [
          {text: 'Data', all: false, name: 'data_manager'},
          {text: 'Api', all: false, name: 'api_manager'},
          {text: 'Function', all: false, name: 'function_manager'}
        ],
        invites: [
          {email: '', privileges: {"data_manager": false, "api_manager": false, "function_manager": false}},
        ],
        dictionary: {
          email: function() {
            return "this is not a correct email"
          }
        },
      }
    },
    mounted: function(){
      Object.keys(this.dictionary).forEach((key) => {
        this.$validator.extend(key, this.dictionary[key])
      })
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      markAll(privilege){
        privilege.all = !privilege.all
        var invite
        for (invite in this.invites){
          this.invites[invite].privileges[privilege.name]=privilege.all
        }
      },
      addInvite(){
        this.invites.push({email: '', privileges: {"data_manager": false, "api_manager": false, "function_manager": false}})
      },
      deleteInvite(index){
        if (this.invites.length>1)
          this.invites.splice(index, 1)
      },
      sendInvite(){
        this.invites=this.invites.filter(function(obj){
          return obj.email !== ''
        })
        if (this.invites.length > 0) {
          this.$validator.validateAll().then(isValid => {
            if (isValid) {
              SettingsService.sendInvite(this.invites, this)
            }
          })
        }
      }
    }
  }
</script>
